import React, { Component } from 'react';
import { connect } from 'react-redux';
import WishlistButton from '../Components/WishListButton';
import { catchError } from '../Actions/Error.action';
import withReactiveStyleBuyButton from './withReactiveStyleBuyButton';
import WishlistAdd from './WishList.add';

class BuyButtonContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showInfo: false,
        };
    }

    render() {
        const onToggle = () => {
            this.setState((prevState) => ({
                showInfo: !prevState.showInfo,
            }));
        };

        return (
            <div>
                {this.state.showInfo == true && (
                    <WishlistAdd
                        onClose={() => onToggle()}
                        articleNumber={this.props.articleNumber}
                    />
                )}
                <WishlistButton {...this.props} onClick={() => onToggle()} />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        onSuccess: (cart) => {
            //todo
        },
        onError: (ex) => {
            dispatch(catchError(ex, (error) => loadError(error)));
        },
    };
};

const loadError = (error) => ({
    type: 'WISHLIST_LOAD_ERROR',
    payload: {
        error,
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withReactiveStyleBuyButton(BuyButtonContainer, 'buy-button-container'));
